import { Typography } from 'antd'
import React from 'react';
import Legend from '../../../../components/Legend/Legend';
import { Trans, useTranslation } from 'react-i18next';

export default function HelpTab() {
    const { t } = useTranslation("habitats");

    return <>
        <Typography.Title level={4}>{t("ohjeetOtsikko")}</Typography.Title>
        <p>
            <span><Trans i18nKey={"habitats:ohjeetEkaRivi"} components={{
                i: <i className="esri-icon-layers" style={{ "fontWeight": "bold" }} />
            }}>
                Karttatasoja voi valita näkyviin oikean alanurkan <i className="esri-icon-layers" style={{ "fontWeight": "bold" }} />-napin takaa.
            </Trans></span>
        </p>
        <p>
            <span>{t("ohjeetTokaRivi")}</span>
        </p>
        <p>
            <Trans i18nKey={"habitats:ohjeetKolmasRivi"} components={{
                i: <i className="esri-icon-tracking" style={{ "fontWeight": "bold" }} />
            }}>Kartan voi tarkentaa omaan sijaintiin painamalla oikean alanurkan <i className="esri-icon-tracking" style={{ "fontWeight": "bold" }} />-nappulaa.</Trans>
        </p>
        <p>
            <span>{t("ohjeetNeljäsRivi")}</span>
        </p>

        <Legend />
    </>
}